module.exports = __webpack_public_path__ + "static/media/warning.80a11b69.svg";